'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var timePicker = require('./time-picker-7099b0c7.js');

var TimePickerStyled = styled__default(timePicker.TimePicker)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  border: 0 none;\n"], ["\n  border: 0 none;\n"])));
var templateObject_1;

exports.TimePickerStyled = TimePickerStyled;
